import cn from "classnames";
import React from "react";
import styles from "./Drawer.module.css";
import closeIcon from "../../images/close.svg";

const strings = {
    closeDrawer: "Close Drawer",
};

type Props = {
    children?: React.ReactNode;
    onClose?: () => void;
    size: "small" | "medium" | "large";
    closeButtonLabel?: string;
};

const getDrawerSizingStyle = (size: "small" | "medium" | "large") => {
    if (size === "small") {
        return styles.small;
    }

    if (size === "medium") {
        return styles.medium;
    }

    return styles.large;
};

export default function Drawer(props: Props) {
    return (
        <div>
            <div
                className={cn(styles.drawer, getDrawerSizingStyle(props.size))}>
                <button
                    onClick={props.onClose}
                    className={
                        props.closeButtonLabel
                            ? styles.closeButtonWithLabel
                            : styles.closeButton
                    }>
                    {props.closeButtonLabel ? (
                        <span className={styles.closeButtonLabelStyle}>
                            {props.closeButtonLabel}
                        </span>
                    ) : (
                        <img src={closeIcon} alt="close" />
                    )}
                </button>
                {props.children}
            </div>

            <div
                className={styles.shadow}
                onClick={props.onClose}
                role="button"
                aria-label={strings.closeDrawer}
            />
        </div>
    );
}
